import { useAppContext } from "../context/appContext";

export const useGlobalLoader = () => {
  const { 
    isGlobalLoading, 
    setIsGlobalLoading, 
    loadingText, 
    setLoadingText 
  } = useAppContext();

  const showLoader = (text = "") => {
    setLoadingText(text);
    setIsGlobalLoading(true);
  };

  const hideLoader = () => {
    setIsGlobalLoading(false);
    setLoadingText("");
  };

  const withLoader = async (asyncFunction, loadingText = "") => {
    try {
      showLoader(loadingText);
      const result = await asyncFunction();
      return result;
    } finally {
      hideLoader();
    }
  };

  return {
    isGlobalLoading,
    loadingText,
    showLoader,
    hideLoader,
    withLoader,
  };
};
